import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-account-single-ticket-page',
  templateUrl: './account-single-ticket-page.component.html',
  styleUrls: ['./account-single-ticket-page.component.css']
})
export class AccountSingleTicketPageComponent implements OnInit {
  
  pageName = "Ticket Details";

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
